export default __webpack_public_path__ + "static/media/T130_C_BD.1fd5edec.pdf";